import {
    chakra,
    Flex,
    Box,
    Text,
    Link
} from '@chakra-ui/react';

export const Container = chakra(Box, {
    label: 'ManageRollover_Container',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        w: 'calc(100% - 70px)',
        h: '100%',
        mt: '60px',
        overflow: 'auto',
        position: 'relative'
    }
});

export const Header = chakra(Flex, {
    label: 'ManageRollover_Header',
    baseStyle: {
        alignItems: 'center',
        backgroundColor: '#F6F6F8',
        h: '72px',
        color: 'neutral.900',
        mb: '40px',
        p: '10px 32px',
        w: '100%',
        fontSize: '30px',
        lineHeight: '20px',
        fontWeight: 400,
        letterSpacing: '-1%'
    }
});

export const ContentWrapper = chakra(Box, {
    label: 'ManageRollover_ContentWrapper',
    baseStyle: {
        position: 'relative',
        m: '51px 43px',
        minH: '286px',
        border: '2px solid',
        borderColor: 'yellow.400',
        gap: '72px',
        borderRadius: '24px',
        p: '32px'
    }
});

export const Title = chakra(Text, {
    label: 'ManageRollover_Title',
    baseStyle: {
        fontSize: '40px',
        color: 'primary.700',
        fontWeight: 400,
        lineHeight: '130%'
    }
});

export const Description = chakra(Box, {
    label: 'ManageRollover_Description',
    baseStyle: {
        flex: 1,
        fontSize: '20px',
        color: 'neutral.600',
        fontWeight: 400,
        lineHeight: '28.8px',
        letterSpacing: '-0.2px',
        m: '24px 0 32px 0'
    }
});

export const Email = chakra(Link, {
    label: 'ManageRollover_Email',
    baseStyle: {
        color: '#007ACC',
        fontWeight: 700,
        textDecoration: 'none !important'
    }
});
